import React, {useState} from "react";
import Form from 'react-bootstrap/Form';
import {InputGroup} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faSearch } from '@fortawesome/free-solid-svg-icons'

export default function FilterBar(props) {
    const [filterVal,setFilterVal] = useState('');


    return (
        <>
            <InputGroup className="mb-3">
                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                <Form.Control
                    placeholder="Filter"
                    aria-label="filter"
                    onChange={(e)=>{
                        setFilterVal(e.target.value);
                        if(props.callback !== undefined)
                            props.callback(e.target.value);
                    }}
                    value={filterVal}
                />
            </InputGroup>

        </>
    );
}



